import { Form, Input, Row, Col, Switch, Select, DatePicker } from 'antd';
import { useEffect, useRef, useState } from 'react';
import BaseWebEditUniversal, { BaseWebEditUniversalProps } from '../system/BaseWebEditUniversal';
import fetchApi from '../system/fetchApi';
import getList from '../../universal/getList';

const FilesEdit = (props: BaseWebEditUniversalProps) => {
    const [form] = Form.useForm();
    const { defaultService, sendPageData } = props;
    const ref = useRef<any>(undefined);
    const [fileGroupData, setFileGroupData] = useState<any>();
    const [fileValidityPeriodData, setFileValidityPeriodData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(defaultService, {
            query: {
                apiId: 'filesGeneralData',
                apiVariable: 'fileValidityPeriod',
                apiExtend: 'showLists',
                apiData: {
                    sendPageData
                }
            }
        }
        ).then(res => {
            if (res.success) {
                const { fileValidityPeriod } = res.data;
                setFileValidityPeriodData(fileValidityPeriod);
            }
        })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'filesGroup',
                    apiExtend: 'showList',
                    apiData: {
                        sendPageData
                    }
                }
            }).then(res => {
                if (res.success) {
                    setFileGroupData(res.data);
                }
            });
    }, []);

    let extendProps: BaseWebEditUniversalProps = {
        ...props,
        dateOptions: {
            columnNames: ['deletionDate']
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={12}>
                        <Form.Item
                            label="id"
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="文件组"
                            name="filesGroupId"
                            rules={[{ required: true, message: '文件组!' }]}>
                            <Select
                                showSearch
                                placeholder="文件组"
                                optionFilterProp="children"
                                disabled={true}
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(fileGroupData, { itemName: 'groupName' })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="名称"
                            name="originalFileName"
                            rules={[{ required: true, message: '名称!' }]}>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="文件"
                            name="fileName">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="目录"
                            name="destination">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="类型"
                            name="fileType">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="大小"
                            name="fileSize">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="宽度"
                            name="imageWidth">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="小图"
                            name="smallImage">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="高度"
                            name="imageHeight">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={14}>
                        <Form.Item
                            label="fileMD5"
                            name="fileMD5">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            label="用户id"
                            name="userId">
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="有效期"
                            name="fileValidityPeriodId">
                            <Select
                                showSearch
                                placeholder="有效期"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(fileValidityPeriodData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={9}>
                        <Form.Item label="删除日期" name="deletionDate" >
                            <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                </Row>
            )
        }

    };

    return (<BaseWebEditUniversal ref={ref} {...extendProps} />)
}

export default FilesEdit;